export default "__VITE_ASSET__CmK8WLGF__"